import MenuIcon from "./MenuIcon";
import SecondSub from "./secondSub";

export default function SubMenu({ lang, data, groupName = "" }) {
	return (
		<div
			className={`absolute rtl:right-0   is-published  ltr:left-0 top-3 transition group-hover:translate-y-5 translate-y-0 opacity-0 invisible group-hover:opacity-100 group-hover:visible duration-500 ease-in-out group-hover:transform z-50  transform`}
		>
			<div
				className={` ${
					data.length >= 1 ? "px-6 p-2" : " p-6 "
				} relative top-6  bg-gradient-to-t  min-w-[200px] bg-shirinmehr-dark1  text-white rounded-xl shadow-xl `}
			>
				<div
					className={`w-10 h-10 transform divide-y-0 rotate-45 absolute top-0 z-0  bg-shirinmehr-dark1 rtl:-translate-x-24 translate-x-24  transition-transform rtl:group-hover:translate-x-0 ltr:group-hover:translate-x-0 duration-500 ease-in-out rounded-sm`}
				></div>
				<div
					data-bg="divide-x-[1px] divide-white/30   "
					className="flex gap-12 py-2 "
				>
					{data.map((item, index) => (
						<div
							key={index}
							class=" z-10 whitespace-nowrap flex gap-6  group/item "
						>
							{item.link_data.link_type === "text_link" ? (
								<MenuIcon
									sub={item.sub}
									title={item.title}
									link={item.link_data.link}
									target={item.link_data.new_window}
								/>
							) : (
								<div className="rounded-md  group/sub ">
									<MenuIcon
										sub={item.sub}
										title={item.title}
										groupName="item"
									/>
									{item.sub && <SecondSub data={item.sub} />}
								</div>
							)}
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
